import { useMsal } from "@azure/msal-react";
import { backendTokenRequest } from "./authConfig";

export const useShowLoginPopup = () => {
  const { instance } = useMsal();
  return {
    showLoginPopup: async () => instance.loginPopup(backendTokenRequest),
  };
};
